import { useState } from 'react';
import { EPDModel } from 'services/EpdClient';
import EditProductInformationDialog from '../../dialogs/EditProductInformationDialog';
import EpdDetailsGrid from '../EpdDetailsGrid';

type TProps = {
  epd: EPDModel;
  onChangeEpd: any;
  onUploadFile(field: string, file: File): void;
  onRemoveFile(fileId: string): Promise<void>;
  isReadOnly: boolean;
};

const ProductInformation = ({ epd, onChangeEpd, onUploadFile, onRemoveFile, isReadOnly }: TProps) => {
  const [isProductEditOpened, setIsProductEditOpened] = useState<boolean>(false);

  return (
    <>
      <EpdDetailsGrid
        headerLabel={'EPD product information'}
        isReadOnly={isReadOnly}
        data={[
          { key: 'Product description', value: epd.productDescription, isHtml: true, required: true },
          { key: 'UN CPC code', value: epd.uncpcCode?.description },
          { key: 'Products', value: epd.products, isHtml: true },
          { key: 'Geographical scope', value: epd.geographicalScopes?.map((x) => x.name).join('; '), required: true },
        ]}
        onEdit={() => setIsProductEditOpened(true)}
      />
      <EditProductInformationDialog
        isOpened={isProductEditOpened}
        epd={epd}
        onHide={() => setIsProductEditOpened(false)}
        onChangeEpd={onChangeEpd}
        onUploadFile={onUploadFile}
        onRemoveFile={onRemoveFile}
      />
    </>
  );
};

export default ProductInformation;
